import { FC, useEffect } from 'react';
import { Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import { switchTenant } from '@/common/utils/tenantSwitch';

const LocxxTenantSwitchGate: FC<{ tenantId: string; originUrl: string }> = ({ tenantId, originUrl }) => {
  const methods = useMethods({
    switchTenant() {
      switchTenant(tenantId).then(() => {
        window.location.replace(originUrl);
      }, () => {
        window.location.replace('/');
      });
    },
  });

  useEffect(() => {
    methods.switchTenant();
  }, [tenantId, originUrl]);

  return <Spin spinning />;
};

export default LocxxTenantSwitchGate;
